import React, {useEffect, useRef} from "react";
import JsBarcode from "jsbarcode";

// EAN-13 of a loyalty card (code "29…", see clicoo LoyaltyService).
const LoyaltyBarcode = ({code, height = 60, width = 2, className = ""}) => {
    const svgRef = useRef(null);

    useEffect(() => {
        if (!svgRef.current || !code) return;
        try {
            JsBarcode(svgRef.current, code, {
                format: "EAN13",
                height,
                width,
                fontSize: 14,
                margin: 8,
                background: "#ffffff",
                lineColor: "#000000",
            });
        } catch (e) {
            // Invalid EAN-13 (should never happen for server-issued codes) —
            // fall back to a plain CODE128 rendering so the code stays usable.
            JsBarcode(svgRef.current, code, {format: "CODE128", height, width, margin: 8});
        }
    }, [code, height, width]);

    return <svg ref={svgRef} className={className}/>;
};

const escapeHtml = (value) =>
    String(value ?? "").replace(/[&<>"']/g, (c) => ({
        "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
    }[c]));

// Opens a print window with a credit-card-sized loyalty card.
export const printLoyaltyCard = ({code, clientName, shopName}) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    try {
        JsBarcode(svg, code, {format: "EAN13", height: 50, width: 2, fontSize: 14, margin: 4});
    } catch (e) {
        JsBarcode(svg, code, {format: "CODE128", height: 50, width: 2, margin: 4});
    }

    const win = window.open("", "_blank", "width=480,height=360");
    if (!win) return false;
    win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Carte fidélité</title>
<style>
  @page { size: 85.6mm 54mm; margin: 0; }
  body { margin: 0; font-family: Arial, sans-serif; }
  .card { width: 85.6mm; height: 54mm; box-sizing: border-box; padding: 4mm 5mm;
          display: flex; flex-direction: column; justify-content: space-between; }
  .shop { font-size: 11pt; font-weight: bold; }
  .label { font-size: 8pt; color: #555; text-transform: uppercase; letter-spacing: .5px; }
  .client { font-size: 10pt; }
  svg { width: 100%; height: auto; max-height: 26mm; }
</style></head><body><div class="card">
  <div><div class="shop">${escapeHtml(shopName)}</div><div class="label">Carte de fidélité</div></div>
  <div class="client">${escapeHtml(clientName)}</div>
  ${svg.outerHTML}
</div><script>window.onload = function () { window.print(); };</script></body></html>`);
    win.document.close();
    return true;
};

export default LoyaltyBarcode;
